/**
 * Amasty Multiple Wishlist compatibility for ScandiPWA
 * @copyright Scandiweb, Inc. All rights reserved.
 */

// due to a bug in source scandipwa version 4.2.1 we made this plugin as a temporary,
// the `clickOutside` prop is not passed correctly from the container to the component.
// there's no need for this plugin, if the issue is later fixed in scandipwa.
// related issue: https://github.com/scandipwa/scandipwa/issues/4870.

import PropTypes from 'prop-types';

import { isEnabled } from '../util/MultipleWishlist';

const propTypes = (member) => ({
    ...member,
    clickOutside: PropTypes.bool,
});

const defaultProps = (member) => ({
    ...member,
    clickOutside: false,
});

const containerProps = (args, callback, instance) => {
    const { clickOutside } = instance.props;

    // if (!isEnabled()) {
    //     return callback(...args);
    // }

    return {
        ...callback(...args),
        clickOutside,
    };
};

export default {
    'Component/Popup/Container': {
        'static-member': {
            propTypes,
            defaultProps,
        },
        'member-function': {
            containerProps,
        },
    },
};
